import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EnvironmentContext } from '../Context/EnvironmentContext';
import SignUp from '../Login/SignUp';

const ProtectedRoute = ({ children }) => {
    const env = useContext(EnvironmentContext);
    const navigate = useNavigate();
    const [showAuthModal, setShowAuthModal] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (!env.user) {
            setShowAuthModal(true);
        }
    }, [env.user]);

    if (!env.user) {
        return (
            <>
                {showAuthModal && (
                    <div className="modal-overlay">
                        <SignUp
                            onSuccess={() => setShowAuthModal(false)}
                            onCancel={() => {
                                setShowAuthModal(false);
                                navigate('/');
                            }}
                            contextMessage={t('AuthRequiredMessage')}
                            showGuestButton={false}
                        />
                    </div>
                )}
            </>
        );
    }

    return children;
};

export default ProtectedRoute;